'use client'

import { Button } from '@graftcode/design-system'

import styles from './UnauthenticatedBanner.module.scss'

export interface UnauthenticatedBannerProps {
  signUpMessage?: string
  signUpButtonLabel?: string
  onSignUpClick?: () => void
}

export function UnauthenticatedBanner({
  signUpMessage = 'Sign up now to explore the complete Graftcode platform.',
  signUpButtonLabel = 'Sign up',
  onSignUpClick,
}: UnauthenticatedBannerProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <p className={styles.message}>{signUpMessage}</p>
        <Button size="s" variant="primary" onClick={onSignUpClick}>
          {signUpButtonLabel}
        </Button>
      </div>
    </div>
  )
}
